import React, { useCallback, useContext } from "react";
import CountryConfigContext from "../../CountryConfigContext";
import { LANGUAGE_KEY } from "../../CountryContext";
import { FormattedMessage } from "react-intl";

const LanguageSelector = ({slim=false}) => {
  const {
    config: { languages },
  } = useContext(CountryConfigContext);

  const onChange = useCallback((e) => {
    localStorage.setItem(LANGUAGE_KEY, e.target.value);
    window.location.reload();
  }, []);

  if (!languages?.length || languages?.length === 1) {
    return null;
  }

  return (
    <div className="flex w-full justify-between items-center">
      {!slim && (
        <div className="font-semibold text-black-500 text-xs">
          <FormattedMessage id="language" defaultMessage="Lang" />
        </div>
      )}
      <select
        className={`bg-transparent border-0 p-0 text-xs ${slim ? "w-full" : "w-1/3 -mr-3"}`}
        value={localStorage.getItem(LANGUAGE_KEY)}
        onChange={onChange}
      >
        {languages.map((l) => (
          <option key={l.code} value={l.code}>
            {l.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default LanguageSelector;
